import { render, staticRenderFns } from "./mudLosses.vue?vue&type=template&id=4738518b"
import script from "./mudLosses.vue?vue&type=script&lang=ts"
export * from "./mudLosses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports